import { CollectionListContainer } from 'mytours-read-common'
import { CollectionListNavigationParams } from 'mytours-read-common'

import { GetCollectionItemsIndexResponseData } from 'mytours-read-api-typescript'
import { RouteComponentProps } from 'react-router'
import { CollectionItemsSlug } from '../navigation/routes'

export type CollectionListNavigationProps = CollectionListNavigationParams

export function extractCollectionListParamsFromNavigationProps(
	navProps: CollectionListNavigationProps,
): CollectionListContainer.CollectionListContainerOwnProps {
	// we are using Routes for now so we extract navigation props from url in the Route components then pass in directly as separate params
	return navProps
}

export interface CollectionItemsNavigationParams {
	collectionId: number
	collectionVersion: number
	// Collection accountId
	collectionAccountId?: number
	// Item accountId
	accountId?: number
	collectionTitle: string

	title: string
	itemId?: number
}

export function extractCollectionItemsParamsFromNavigationProps(
	navProps: CollectionItemsNavigationParams,
): CollectionItemsNavigationParams {
	return navProps
}

export type BoundDirection = 'prev' | 'next'

export type CollectionItemsRouteParams = RouteComponentProps<{
	type: CollectionItemsSlug
	item: GetCollectionItemsIndexResponseData.ItemSubtypeEnum | 'item'
	itemId: string
}>
